/* eslint-disable import/prefer-default-export */
import { milesToMeters } from '../../../utils/locationHelpers';
import { getEpochForTimeRange } from '../recommendWorkerHelper';

/**
 * Processes filters to clean format for API requests
 * @param {Object} customFilters - The filters object from component state
 * @param {Object} filterConfig - Configuration object for filter processing
 * @returns {Array} Array of clean filter objects for API
 */
export const processFiltersToCleanFormat = (customFilters, filterConfig) => {
  const cleanFilters = [];

  Object.entries(customFilters).forEach(([filterKey, filterValue]) => {
    if (
      filterValue === undefined ||
      filterValue === null ||
      filterValue === false ||
      (typeof filterValue === 'number' && !Number.isFinite(filterValue)) ||
      (Array.isArray(filterValue) && filterValue.length === 0) ||
      (typeof filterValue === 'string' && !filterValue.trim())
    ) {
      return;
    }

    const config = filterConfig[filterKey];
    if (!config) return;

    let processedValue = filterValue;
    if (filterKey === 'lastLoginDate') {
      processedValue = getEpochForTimeRange(filterValue);
      if (!processedValue) return;
    } else if (filterKey === 'distance') {
      processedValue = milesToMeters(filterValue);
      if (!Number.isFinite(processedValue)) return;
    } else if (typeof filterValue === 'string') {
      processedValue = filterValue.trim();
    }

    const filterObject = {
      field: config.field,
      value: processedValue,
    };

    if (config.operation) {
      filterObject.operation = config.operation;
    }
    cleanFilters.push(filterObject);
  });

  return cleanFilters;
};
